import HttpRequest from "../../api/HttpRequest";
import { sendRequest } from "../../api/rootApi";
import Api from "../../constants/Api";

export const getContactLimit = async (payload) => {
    return sendRequest("post", Api.getContactLimit, payload);
};

export const saveContact = async (payload) => {
    return HttpRequest.post(Api.createContact, payload);
};

export const getUserPolicy = (payload) => {
    return HttpRequest.get(Api.getUserPolicy, payload);
};
export const getInsuranceCompany=()=>{
    return HttpRequest.get(Api.getInsuranceCompany);
}